import { PayloadAction, createSlice } from "@reduxjs/toolkit";

/**
 * The DSQ webview session core opened for an order paid with partner points
 * (prepits/project#4468): what `/receipt/create` answered instead of a payment
 * link. The partner-points page reads it to load the webview and hand it the
 * token.
 *
 * Deliberately NOT persisted (the store registers it without
 * redux-persist): the access token is a merchant credential, so it lives in
 * memory only and never reaches storage. A reload drops it, and the page
 * sends the guest back to checkout.
 */
export type DsqpwpWebviewSession = {
  webviewUrl: string;
  accessToken: string;
  receiptId?: number;
  receiptUuid?: string;
};

type DsqPayWithPointsState = {
  session: DsqpwpWebviewSession | null;
};

const initialState: DsqPayWithPointsState = { session: null };

const dsqPayWithPointsSlice = createSlice({
  name: "dsqPayWithPoints",
  initialState,
  reducers: {
    startDsqpwpSession: (
      state,
      { payload }: PayloadAction<DsqpwpWebviewSession>
    ) => {
      state.session = payload;
    },
    clearDsqpwpSession: (state) => {
      state.session = null;
    },
  },
});

export const { startDsqpwpSession, clearDsqpwpSession } =
  dsqPayWithPointsSlice.actions;

export default dsqPayWithPointsSlice.reducer;
